<template>
  <div>
    <div style="margin-bottom: 0.5rem">
      <strong>1. How did you hear about our school?</strong>
    </div>
    <div v-for="(channel, i) in channels" :key="`channel_${i}`">
      <label v-if="channel !== 'NIL'">
        <input class="mr-1" type="radio" name="optradio" v-model="selected" :value="channel" />
        <span v-text="channel"></span>
      </label>
    </div>
    <label>
      <input class="mr-1" type="radio" name="optradio" value="Others" :checked="!channels.includes(selected)" @click="selected = ''" />
      <span>Others, please specify:</span>
      <input v-if="!channels.includes(selected)" class="form-control m-0" type="text" v-model="selected" />
    </label>
  </div>
</template>

<script>
const SCHOOLS = {
  MIS: 'Middleton',
  EIS: 'Bhutan International School',
  EH: 'EtonHouse',
}

export default {
  props: ['channel', 'group'],
  data() {
    return {
      selected: this.channel || 'NIL',
    }
  },
  watch: {
    selected(value) {
      this.$emit('change', value)
    },
    channel(val) {
      if (this.selected !== val) {
        this.selected = val
      }
    },
  },
  computed: {
    schoolName() {
      return SCHOOLS[this.group] ?? SCHOOLS.EH
    },
    channels() {
      return [
        `NIL`,
        `Magazines / Publication`,
        `Social Media`,
        `Advertisement`,
        `Online Search`,
        `Education Fairs / Webinars`,
        `Relocation / Student Recruitment Agent`,
        `Company's HR`,
        `Parent of ${this.schoolName}`,
        `Relatives / Friends`,
      ]
    },
  },
}
</script>
